import type { FC, HTMLAttributeAnchorTarget } from 'react';

import { Link } from '@backstage/core-components';
import { Icon } from '@iconify/react';
import { IconButton, Tooltip } from '@mui/material';
import { tss } from 'tss-react/mui';

const useStyles = tss.create(({ theme }) => ({
  helpIcon: {
    color: theme.palette.common.black,
    height: 30,
    width: 30,
  },
}));

type Props = {
  link: string;
  target?: HTMLAttributeAnchorTarget;
};

export const InfoButton: FC<Props> = ({ link, target }) => {
  const { classes } = useStyles();

  return (
    <Tooltip placement="top" title="Further information">
      <IconButton aria-label="Infos" component={Link} target={target} to={link}>
        <Icon
          className={classes.helpIcon}
          icon="material-symbols:help-outline"
        />
      </IconButton>
    </Tooltip>
  );
};
